import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";

export type WizardStepTitleProps = {
  stepNumber: number;
  title: string;
  subtitle?: string | JSX.Element;
};

export const WizardStepTitle: React.FC<WizardStepTitleProps> = ({ stepNumber, title, subtitle }) => {
  return (
    <div className="d-flex flex-column mb-5">
      <div className="fw-bold">
        <FontAwesomeIcon icon={faCircle} color="red" /> Step {stepNumber}: {title}
      </div>
      <div className="text-muted">{subtitle}</div>
    </div>
  );
};
